import {ReactElement} from 'react'
import {Trans} from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import messages from '../../../../../assets/messages'
import Loading from '../../../../Common/Loading'
import {useProvider} from '../../hooks/useProvider'
import {PerformanceFeeInput} from './components/PerformanceFeeInput'
import {IsProvidingInput} from './components/IsProvidingInput'

type Account = {
  id: number
  isViewOnly: boolean
  isReadOnly: boolean
  __typename: string
}

type BrokereeCopyTradingProviderSettingsProps = {
  account: Account
  onUpdated: () => void
}

const DEFAULT_PERFORMANCE_FEE = 10

export const BrokereeCopyTradingProviderSettings = (props: BrokereeCopyTradingProviderSettingsProps): ReactElement | null => {
  const {account, onUpdated} = props
  const {id: accountId, isViewOnly, isReadOnly} = account

  const canProvide = !isViewOnly && !isReadOnly

  const {provider, loading, error, refetch} = useProvider(accountId)

  const handlePerformanceFeeUpdated = async (): Promise<void> => {
    await refetch()
    onUpdated()
  }

  const handleIsProvidingUpdated = async (): Promise<void> => {
    await refetch()
    onUpdated()
  }

  if (error != null) return null
  if (loading) return <Loading />

  const isProviding = (provider?.isProviding ?? false) && provider?.offer != null
  const performanceFee = provider?.offer?.performanceFee ?? DEFAULT_PERFORMANCE_FEE
  const hasActiveSubscriptions = Boolean(provider?.hasActiveSubscriptions)

  const shouldValidatePassword = !Boolean(provider?.externalPerformanceFeeAccountId)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h3"><Trans {...messages.copyTradingSettings} /></Typography>
      </Grid>
      <PerformanceFeeInput
        accountId={accountId}
        value={performanceFee}
        hasActiveSubscriptions={hasActiveSubscriptions}
        disabled={isProviding || !canProvide || hasActiveSubscriptions}
        onUpdated={handlePerformanceFeeUpdated}
      />
      <IsProvidingInput
        accountId={accountId}
        value={isProviding}
        shouldValidatePassword={shouldValidatePassword}
        disabled={!isProviding && !canProvide}
        onUpdated={handleIsProvidingUpdated}
      />
    </Grid>
  )
}
